// extracted by mini-css-extract-plugin
var _1 = "_productManagementDiscountDetails-module__action-button-disabled";
var _2 = "_productManagementDiscountDetails-module__container";
var _3 = "_productManagementDiscountDetails-module__edit-button";
var _4 = "_productManagementDiscountDetails-module__form-action-button-disabled";
var _5 = "_productManagementDiscountDetails-module__loader";
var _6 = "_productManagementDiscountDetails-module__submit-button";
export { _1 as "action-button-disabled", _2 as "container", _3 as "edit-button", _4 as "form-action-button-disabled", _5 as "loader", _6 as "submit-button" }
